import { Link } from "react-router-dom";
import { CalendarClock, MailWarning, ArrowRight } from "lucide-react";
import { formatDate } from "@/lib/api";

const daysLeft = (iso) => Math.ceil((new Date(iso + "T00:00:00") - new Date().setHours(0, 0, 0, 0)) / 86400000);

export const AttentionPanels = ({ data }) => (
  <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
    <div className="panel p-6 animate-rise delay-2" data-testid="expiring-contracts-card">
      <div className="flex items-center justify-between">
        <p className="eyebrow flex items-center gap-2"><CalendarClock className="h-4 w-4 text-amber-500" /> Contratti in scadenza</p>
        <Link to="/scadenze" className="text-xs font-medium text-[#3d6e49] hover:underline" data-testid="view-contracts-link">Vai alle scadenze</Link>
      </div>
      <ul className="mt-4 divide-y divide-slate-100">
        {data.contracts_expiring?.length ? data.contracts_expiring.map((c) => {
          const d = daysLeft(c.data_fine);
          return (
            <li key={c.employee_id} className="flex items-center justify-between gap-3 py-3" data-testid={`expiring-${c.employee_id}`}>
              <div className="min-w-0">
                <p className="truncate text-sm font-medium text-slate-900">{c.name}</p>
                <p className="truncate text-xs text-slate-500">{[c.tipologia, c.mansione].filter(Boolean).join(" · ") || "—"}</p>
              </div>
              <div className="text-right">
                <p className="text-sm font-medium text-slate-900">{formatDate(c.data_fine, false)}</p>
                <p className={`text-xs ${d <= 7 ? "text-rose-600" : "text-amber-700"}`}>{d <= 0 ? "scade oggi" : `tra ${d} giorni`}</p>
              </div>
            </li>
          );
        }) : <li className="py-3 text-sm text-slate-500" data-testid="expiring-empty">Nessun contratto in scadenza nei prossimi 30 giorni.</li>}
      </ul>
      {(data.contracts_expired > 0 || data.contracts_unmatched > 0) && (
        <p className="mt-3 text-xs text-slate-500" data-testid="contracts-extra-hint">
          {data.contracts_expired > 0 && <span className="mr-3">{data.contracts_expired} dipendenti attivi con contratto scaduto</span>}
          {data.contracts_unmatched > 0 && <span>{data.contracts_unmatched} documenti da abbinare</span>}
        </p>
      )}
    </div>
    <div className="panel p-6 animate-rise delay-3" data-testid="no-email-card">
      <div className="flex items-center justify-between">
        <p className="eyebrow flex items-center gap-2"><MailWarning className="h-4 w-4 text-amber-500" /> Dipendenti senza email</p>
        <Link to="/dipendenti" className="text-xs font-medium text-[#3d6e49] hover:underline" data-testid="view-employees-link">Completa <ArrowRight className="ml-1 inline h-3 w-3" /></Link>
      </div>
      {data.employees_without_email_list?.length ? (
        <div className="mt-4 flex flex-wrap gap-1.5">
          {data.employees_without_email_list.slice(0, 40).map((e) => (
            <Link key={e.id} to="/dipendenti" className="rounded-full border border-amber-200 bg-amber-50 px-2.5 py-0.5 text-xs text-amber-900 hover:bg-amber-100" data-testid={`no-email-${e.id}`}>{e.name}</Link>
          ))}
          {data.employees_without_email_list.length > 40 && <span className="text-xs text-slate-500">+{data.employees_without_email_list.length - 40} altri</span>}
        </div>
      ) : <p className="mt-4 text-sm text-slate-500" data-testid="no-email-empty">Tutti i dipendenti attivi hanno un'email.</p>}
    </div>
  </div>
);
